module.exports = __webpack_public_path__ + "assets/img/3ef68c222634db2a17a0924b5ab2fd9d.png";